import React from 'react'
import styled from 'styled-components'

import Spinner from '../../Spinner'

const Wrapper = styled.div`
  text-align: center;
  font-size: 1.5em;
  width: 100%;
`

const Loader = (): React.ReactElement => {
  return (
    <Wrapper>
      <Spinner size={20} />
    </Wrapper>
  )
}

export default Loader
